import React from "react";
import { FaGamepad, FaCogs, FaRocket } from "react-icons/fa";
import "../style/HomeSections.css";

const platformPillars = [
  {
    icon: FaGamepad,
    title: "Sviluppare giochi Kyros",
    summary: "Partiamo da prototipi nostri e li portiamo sul sito solo quando c'è qualcosa di concreto da mostrare o provare.",
    focus: ["Prototipi interni", "Pagina del gioco", "Stato chiaro"],
    href: "/services#sviluppo-interno"
  },
  {
    icon: FaCogs,
    title: "Distribuire dal launcher",
    summary: "Account, libreria e download stanno nello stesso percorso, così chi gioca non deve cercare file o link sparsi.",
    focus: ["Account Kyros", "Libreria personale", "Installazione Windows"],
    href: "/services#launcher-kyros"
  },
  {
    icon: FaRocket,
    title: "Usare bene i playtest",
    summary: "Quando un gioco non è pronto per lo Store, lo diciamo. I test servono a capire cosa funziona prima di venderlo.",
    focus: ["Build in prova", "Feedback leggibile", "Stato aggiornato"],
    href: "/services#community-loop"
  }
];

export default function HomeServicesPreview() {
  return (
    <section className="home-services-preview">
      <div className="home-section__inner">
        <header className="home-services-preview__header">
          <span className="home-eyebrow">Piattaforma Kyros</span>
          <h2>Videogame autoprodotti, Store e launcher nello stesso posto</h2>
          <p>
            Kyros non è un catalogo aperto a giochi di altri: è il posto dove mettiamo in ordine
            i nostri titoli, dal download gratuito alla scheda di vendita.
          </p>
        </header>

        <div className="home-services-preview__grid">
          {platformPillars.map(pillar => {
            const Icon = pillar.icon;
            return (
              <article key={pillar.title} className="home-services-preview__card">
                <div className="home-services-preview__icon">
                  <Icon aria-hidden="true" />
                </div>
                <h3>{pillar.title}</h3>
                <p>{pillar.summary}</p>
                <ul>
                  {pillar.focus.map(item => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <a className="home-services-preview__link" href={pillar.href}>
                  Leggi di più
                </a>
              </article>
            );
          })}
        </div>

        <a className="home-button home-button--outline home-services-preview__cta" href="/services">
          Scopri la piattaforma
        </a>
      </div>
    </section>
  );
}
